module.exports = __webpack_public_path__ + "static/media/add_news_column_ja.51de3609.gif";